import React from "react";

const blue = "#2D75AD";
const BlockList = ({
  color = blue,
  viewBox = "0 0 22 22",
  width = 20,
  height = 20,
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={height}
    width={width}
    viewBox={viewBox}
    {...rest}
  >
    <g fill={color} fillRule="nonzero">
      <path d="M12.53 8.837l-1.566 1.512a.648.648 0 01-.3 0H7.419a.76.76 0 00-.737.481.73.73 0 00.23.87c.157.109.34.172.53.184h1.612l-.138.137-1.336 1.398c-.145.105-.207.227-.368.304l-.576.528L2.514 18h-.161A10.858 10.858 0 01.649 7.555 10.67 10.67 0 019.629.133a10.95 10.95 0 019.371 3l-1.266 1.123-3.247 2.91a.577.577 0 01-.391.137H7.418a.782.782 0 00-.783.641c-.062.4.185.783.576.893h5.319zm-7.437 0a.78.78 0 00.783-.778.78.78 0 00-.783-.78.78.78 0 00-.783.78c0 .43.35.778.783.778zm0 3.093c.21 0 .41-.086.554-.238a.754.754 0 00.206-.564.731.731 0 00-.224-.55.739.739 0 00-.56-.206.762.762 0 00-.782.756.777.777 0 00.783.802h.023zm0 3.16a.762.762 0 00.56-.22.754.754 0 00.223-.558.754.754 0 00-.223-.558.762.762 0 00-.56-.22.78.78 0 00-.783.778.754.754 0 00.76.779h.023zM9.816 21.962c-.37-.034-.755-.087-1.154-.16a11.165 11.165 0 01-5.655-2.834.226.226 0 010-.114l.947-.846 3.3-3.039a.58.58 0 01.392-.137h9.048a.785.785 0 00.784-.503.727.727 0 00-.254-.868.86.86 0 00-.53-.16H9.239v-.16l1.708-1.508h5.77a.788.788 0 00.79-.34.77.77 0 000-.852.788.788 0 00-.79-.34h-3.97v-.137l1.477-1.302a.443.443 0 01.3 0h2.1a.766.766 0 00.586-.22.75.75 0 00.222-.58.774.774 0 00-.246-.543.79.79 0 00-.562-.211c-.16.022-.324.022-.484 0L19.67 4c.278.411.578.8.809 1.211a10.977 10.977 0 01-1.547 13.186 11.02 11.02 0 01-6.531 3.45c-.177.043-.512.081-1.005.115-.74.05-1.025.05-1.58 0z" />
    </g>
  </svg>
);

export default BlockList;
